import { createContext, useState, useContext } from 'react';

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const [activeModels, setActiveModels] = useState([]);

  const deployModel = (model) => {
    setActiveModels((prev) => {
      const isExist = prev.find((item) => item._id === model._id && item.selectedTier === model.selectedTier);
      if (isExist) return prev;
      return [...prev, { ...model, deploymentId: Date.now() }];
    });
  };

  const revokeAccess = (deploymentId) => {
    setActiveModels((prev) => prev.filter((item) => item.deploymentId !== deploymentId));
  };

  return (
    <ApiContext.Provider value={{ activeModels, deployModel, revokeAccess }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApi = () => useContext(ApiContext);